"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackingProvider = exports.useTrackingContext = exports.TrackingContext = void 0;
var react_1 = __importDefault(require("react"));
var createTrackingFunctions_1 = __importDefault(require("./createTrackingFunctions"));
/** Placeholder trackEvent to feed into defaultContext. This should never be used. */
var defaultTrackEvent = function ( /* eventName, metaData */) { return Promise.resolve(); };
var defaultContext = createTrackingFunctions_1.default(defaultTrackEvent);
exports.TrackingContext = react_1.default.createContext(defaultContext);
exports.useTrackingContext = function () {
    return react_1.default.useContext(exports.TrackingContext);
};
exports.TrackingProvider = function (_a) {
    var children = _a.children, propsTrackingFunctions = _a.trackingFunctions, metadata = _a.metadata;
    var trackingFunctions = exports.useTrackingContext();
    // Context TrackingFunctions may be overridden by props.trackingFunctions
    if (propsTrackingFunctions) {
        // @ts-ignore these two types are not exactly the same because
        // trackEvent is the only required prop.
        trackingFunctions = propsTrackingFunctions;
    }
    /*
     * If metadata is provided, enhance TrackingFunctions with it.
     * Metadata is enhanced for descendants within context boundaries.
     * TrackingProvider may live within boundaries of other TrackingProvider
     * to allow for progressive enhancement of metadata down the component hierarchy.
     */
    if (metadata) {
        var trackEvent_1 = trackingFunctions.trackEvent;
        trackingFunctions = createTrackingFunctions_1.default(function (eventName, eventData) {
            return trackEvent_1(eventName, __assign(__assign({}, metadata), eventData));
        });
    }
    return (react_1.default.createElement(exports.TrackingContext.Provider, { value: trackingFunctions }, children));
};
